module.exports = __webpack_public_path__ + "img/会员条@2x.820fcd4f.png";